import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { faCheck, faCopy } from '@fortawesome/free-solid-svg-icons';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-clipboard-copy',
  templateUrl: './clipboard-copy.component.html',
  styleUrls: ['./clipboard-copy.component.sass']
})

export class ClipboardCopyComponent implements AfterViewInit {

  faCheck = faCheck;
  faCopy = faCopy;

  @Input() textToCopy: string = '';
  @Input() iconSize: number = 16;
  @Input() copySuccessDuration: number = 2000;

  isCopied: boolean = false;

  @ViewChild('copyButton') copyButton!: any; 
  private tooltip!: bootstrap.Tooltip;

  ngAfterViewInit(): void {

    this.tooltip = new bootstrap.Tooltip(this.copyButton.nativeElement, {
      title: 'Copied!',
      trigger: 'manual'
    });

  };

  async copy(): Promise<void> {

    if (!this.textToCopy || this.textToCopy.trim() === '') {
      console.warn('No text to copy.');
      return;
    };

    try {
      
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(this.textToCopy);

      } else {
        this.fallbackCopy();
      };

      this.isCopied = true;
      this.tooltip.show();

      setTimeout(() => {
        this.tooltip.hide();
        this.isCopied = false;
      }, this.copySuccessDuration);

    } catch (error) {
      console.error('Copy failed:', error);
    }
  }

  private fallbackCopy(): void {
    const textarea = document.createElement('textarea');
    textarea.value = this.textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  };

}
